import apiService from '../api/apiService';
import  {Order , PackageDetails , GetMerchantOrdersApiResponse}  from '../types/orderTypes';
import { AxiosResponse } from 'axios';

const OrdersController = {
  getOrders: (): Promise<AxiosResponse<any>> => apiService.get<any>('/orders/merchant'),
  // Ready to Ship: places the order on Shiprocket and books the courier.
  postSubOrderDetails: (data : PackageDetails ): Promise<AxiosResponse<Order[]>> => apiService.post<Order[]>('/orders/create-sub-order-shipping' , data),
  // Step before Ready to Ship: the merchant approves the new order.
  approveSubOrder: (subOrderId: string): Promise<AxiosResponse<any>> =>
    apiService.patch<any>(`/orders/merchant/sub-orders/${subOrderId}/approve`),
  // Delivery charge asked fresh from Shiprocket for this order (no pop-up on failure: the dialog says it).
  getLiveShippingQuote: (subOrderId: string): Promise<AxiosResponse<any>> =>
    apiService.get<any>(`/orders/merchant/sub-orders/${subOrderId}/shipping-quote`, undefined, { silentError: true } as any),
  // GET /orders/track/shipment/{subOrderId} — pulls live shipment tracking
  // from Shiprocket via the monolith. The earlier path `/orders/delivery-status/{id}`
  // did not exist on the backend and would 404 silently.
  getDeliveryStatus: (subOrderId: string): Promise<AxiosResponse<any>> =>
    apiService.get<any>(`/orders/track/shipment/${subOrderId}`),
  getMerchantOrders : (
    // page is zero-based on the backend (Spring PageRequest) — defaulting to 1
    // requested the (empty) SECOND page, so the merchant's orders never showed.
    page = 0,
    size = 10
  ): Promise<AxiosResponse<any>> => {
    return apiService.get('/orders/merchant',  { page, size },);
  },
  getMerchantDashboardSummary: (): Promise<AxiosResponse<any>> =>
    apiService.get('/orders/merchant/dashboard-summary'),
};

export default OrdersController;
